import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InterpretationService } from '../../../interpretation.service';
import { InspectionForecastPreferenceModel, TRACKForcastVM } from '../../../models/interpretation.model';
import moment from 'moment';
import { NotificationsService } from 'angular2-notifications';
import { PreferencesService } from '../../../../../../app/modules/preferences/preferences.service';
import { PmServiceTypes, PmServiceTypesVM } from '../../../../../../app/modules/setup-equipment/setup-equipment.model';
import { SetupEquipmentService } from '../../../../../../app/modules/setup-equipment/setup-equipment.service';

@Component({
  selector: 'app-forecast-setting-popup',
  templateUrl: './forecast-setting-popup.component.html',
  styleUrls: ['./forecast-setting-popup.component.scss']
})
export class ForecastSettingPopupComponent implements OnInit {

  constructor(private _planerService: SetupEquipmentService, private _pref: PreferencesService, private _notify: NotificationsService, public dialogRef: MatDialogRef<ForecastSettingPopupComponent>, private _interp: InterpretationService, @Inject(MAT_DIALOG_DATA) private _data: any) { }
  reqPattern = 'dd/MM/yyyy';
  InspectionId: number;
  unitno: string = '';
  ngOnInit(): void {
    this.InspectionId = this._data.inspectionId;
    this.unitno = this._data.unitno;
    this.getDailyUsagehoursAndDailyDistance();
    this.CheckForUnitNumber();
    this.getUserUOD();
    this.GetPmServiceData();
  }

  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  ForecastData = new FormGroup({
    Daily_Usage_Hours: new FormControl(),
    Daily_Usage_Distance: new FormControl(),
    DistanceRatio: new FormControl(),
    Forecast_Method: new FormControl('1'),
    PM_1_Date: new FormControl(Validators.pattern(this.reqPattern)),
    PM_2_Date: new FormControl(Validators.pattern(this.reqPattern)),
    Floating_Date: new FormControl(Validators.pattern(this.reqPattern)),
    Floating_Date2: new FormControl(Validators.pattern(this.reqPattern)),
    Daily_Usage_Calculation_Method: new FormControl('1'), // Default value as '1'
    show120Worn: new FormControl(),
    show100Worn: new FormControl(),
    showLastFourth: new FormControl(),
    PmNextServiceType: new FormControl(),
    PmSecondServiceType: new FormControl(),
    FloatingDate1ServiceType: new FormControl(),
    FloatingDate2ServiceType: new FormControl(),
    SafteyFactor: new FormControl(),
    WeatherType: new FormControl(),
    PresetAvg: new FormControl('1'),
    MidpointPercentage: new FormControl(),
  })
  GetActionType = 1;
  onNoClick() {
    this.dialogRef.close(false);
  }
  ModelMachineLevel: boolean;
  CheckForUnitNumber() {
    this._interp.CheckForUnitNumber(this.unitno).subscribe(result => {
      if (result == true) {
        this.ModelMachineLevel = true
      } else {
        this.ModelMachineLevel = false
      }
    });
  }
  selectedValue = '1'
  BoolRadioCheck: boolean = true;
  onforecastMethodCalution(Value: number) {
    if (Value == 1) {
      this.selectedValue = '1';
      this.BoolRadioCheck = true
    } else {
      this.selectedValue = '2';
      this.BoolRadioCheck = false
    }
  }
  userUOD: string = "";
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }
  forecastDataVM: TRACKForcastVM;
  NextPMSMU: number = 0;
  NextPmDistance: number = 0;
  SecondPMSMU: number = 0;
  SecondDistance: number = 0;
  FloatingSMU: number;
  FloatingDistance: number = 0;
  FloatingSMU2: number = 0;
  FloatingDistance2: number = 0;
  PmNextDate: Date;
  Pm2NextDate: Date;
  FloatingDate: Date;
  FloatingDate2: Date;
  calculatedUsaghourChecked: boolean = true;
  conditionalCalculatedValue: boolean = true;
  dayDiff: number = 0;
  dayDiff1: number = 0;
  dayDiff2: number = 0;
  dayDiff3: number = 0;
  hourChecked: boolean = true;
  diffBetweenLastandPreviousInpectionUsgHours1: number = 0;
  diffBetweenLastandPreviousInpectionUsgHours2: number = 0;
  diffBetweenLastandPreviousInpectionUsgHours3: number = 0;
  diffBetweenLastandPreviousInpectionUsgHours4: number = 0;
  diffBetweenLastandPreviousInpectionDistance1: number = 0;
  diffBetweenLastandPreviousInpectionDistance2: number = 0;
  diffBetweenLastandPreviousInpectionDistance3: number = 0;
  diffBetweenLastandPreviousInpectionDistance4: number = 0;
  InspectionForecastPreferenceModel: InspectionForecastPreferenceModel = new InspectionForecastPreferenceModel();
  onRadioChange(value: number) {
    if (value == 1) {
      this.calculatedUsaghourChecked = true;
    } else {
      this.calculatedUsaghourChecked = false;
    }
    if (this.GetActionType == 41) {
      if (this.forecastDataVM != null) {
        var _Method = this.ForecastData.controls['Daily_Usage_Calculation_Method'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          const start = new Date(this.InspectionForecastPreferenceModel.EventDate).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));
          if (_Method == 1) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.Smu);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }

        }
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {

          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }


        }
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
        }
      }
    }
    else {
      if (this.forecastDataVM != null) {
        var _Method = this.ForecastData.controls['Daily_Usage_Calculation_Method'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          const start = new Date(this.forecastDataVM.LastInpectionDateOnly).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));
          if (_Method == 1) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }

        }
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {

          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }


        }
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {
            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (_Method == 1) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }

        }
      }
    }
  }
  OnUsageRadioValChange(value: number) {
    if (value == 1) {
      this.hourChecked = true;
    } else {
      this.hourChecked = false;
    }
  }

  getDailyUsagehoursAndDailyDistance() {
    this._interp.getDailyUsageHoursAndDistance(this.InspectionId).subscribe(result => {
      this.forecastDataVM = result;
      this.ForecastData.controls['DistanceRatio'].setValue(this.forecastDataVM.DistanceRatio);
      if (this.forecastDataVM.ForecastMethod != "" && this.forecastDataVM.ForecastMethod != null) {
        if (this.forecastDataVM.ForecastMethod == "Hours") {
          this.hourChecked = true;
          this.ForecastData.controls['Forecast_Method'] = new FormControl('1')

        } else {
          this.hourChecked = false;
          this.ForecastData.controls['Forecast_Method'] = new FormControl('2')
        }
      }
      else {
        this.hourChecked = true;
      }


      if (this.forecastDataVM.DailyUsageCalculationMethod != "" && this.forecastDataVM.DailyUsageCalculationMethod != null) {
        if (this.forecastDataVM.DailyUsageCalculationMethod == "calculated") {
          this.calculatedUsaghourChecked = true;
          this.conditionalCalculatedValue = true;
          this.ForecastData.controls['Daily_Usage_Calculation_Method'] = new FormControl('1')
        } else {
          this.calculatedUsaghourChecked = false;
          this.conditionalCalculatedValue = false;
          this.ForecastData.controls['Daily_Usage_Calculation_Method'] = new FormControl('2')
        }
      } else {
        this.calculatedUsaghourChecked = true;
        this.conditionalCalculatedValue = true;
      }

      this.selectedValue = this.forecastDataVM.ForecastCalculationMethod.toString();
      if (this.forecastDataVM.ForecastCalculationMethod == 1) {
        this.BoolRadioCheck = true
        this.ForecastData.controls['PresetAvg'] = new FormControl('1')
      } else {
        this.BoolRadioCheck = false
        this.ForecastData.controls['PresetAvg'] = new FormControl('2')
      }
      this.NextPmDistance = this.forecastDataVM.PmNextDateServiceDOE;
      this.NextPMSMU = this.forecastDataVM.PmNextDateServiceSMU;

      this.SecondDistance = this.forecastDataVM.SecondPmNextDateServiceDOE;
      this.SecondPMSMU = this.forecastDataVM.SecondPmNextDateServiceSMU;
      this.FloatingDistance = this.forecastDataVM.FloatingDOE;
      this.FloatingSMU = this.forecastDataVM.FloatingSMU;
      this.FloatingDistance2 = this.forecastDataVM.FloatingDOE2;
      this.FloatingSMU2 = this.forecastDataVM.FloatingSMU2;
      this.ForecastData.controls['Daily_Usage_Hours'].setValue(this.forecastDataVM.DailyUsageHours);
      this.ForecastData.controls['Daily_Usage_Distance'].setValue(this.convertDistanceKmToMi(this.forecastDataVM.DailyUageDistance));
      this.ForecastData.controls['SafteyFactor'].setValue(this.forecastDataVM.SafetyFactor);
      this.ForecastData.controls['WeatherType'].setValue(this.forecastDataVM.WeatherTypeId);
      this.ForecastData.controls['PM_1_Date'].setValue(this.forecastDataVM.PmNextDateService);
      this.ForecastData.controls['PM_2_Date'].setValue(this.forecastDataVM.SecondPmNextDateService);
      this.ForecastData.controls['Floating_Date'].setValue(this.forecastDataVM.FloatingDate);
      this.ForecastData.controls['Floating_Date2'].setValue(this.forecastDataVM.FloatingDate2);
        this.ForecastData.controls['MidpointPercentage'].setValue(this.forecastDataVM.MidpointPercentage);
      this.ForecastData.controls['show100Worn'].setValue(this.forecastDataVM.Show100Worn);
      this.ForecastData.controls['show120Worn'].setValue(this.forecastDataVM.Show120Worn);
      this.ForecastData.controls['showLastFourth'].setValue(this.forecastDataVM.ShowLastFourth);
      this.ForecastData.controls['PmNextServiceType'].setValue(this.forecastDataVM.PmNextServiceType);
      this.ForecastData.controls['PmSecondServiceType'].setValue(this.forecastDataVM.PmSecondServiceType);
      this.ForecastData.controls['FloatingDate1ServiceType'].setValue(this.forecastDataVM.FloatingDate1ServiceType);
      this.ForecastData.controls['FloatingDate2ServiceType'].setValue(this.forecastDataVM.FloatingDate2ServiceType);

      if (this.forecastDataVM.PmNextDateService != null) {
        this.onNextPmDateChange(1)
      }
      if (this.forecastDataVM.SecondPmNextDateService != null) {
        this.onNextPmDateChange(2)

      }
      if (this.forecastDataVM.FloatingDate != null) {
        this.onNextPmDateChange(3)

      }
      if (this.forecastDataVM.FloatingDate2 != null) {
        this.onNextPmDateChange(4)

      }
    });
  }
  _minDateNextPm: Date = new Date();
  _minDateSecoundPm: Date = new Date();
  _minDateFlaotingDate1: Date = new Date();
  _minDateFlaotingDate2: Date = new Date();
  onNextPmDateChange(value: number) {


    if (this.GetActionType == 41) {
      if (value == 1) {
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          this._minDateSecoundPm = this.ForecastData.controls['PM_1_Date'].value;
          const start = new Date(this.InspectionForecastPreferenceModel.EventDate).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));

          if (this.calculatedUsaghourChecked) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.InspectionForecastPreferenceModel.Smu);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.Smu);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.InspectionForecastPreferenceModel.TotalDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.InspectionForecastPreferenceModel.Smu);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.InspectionForecastPreferenceModel.TotalDistance)
          }

        }

      } else if (value == 2) {
        this.conditionalCalculatedValue = false;
        this._minDateFlaotingDate1 = this.ForecastData.controls['PM_2_Date'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {

          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff1 - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance);
          }


        }

      } else if (value == 3) {
        this._minDateFlaotingDate2 = this.ForecastData.controls['Floating_Date'].value;
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {

            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff2 - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));

          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance);
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }

        }

      } else {

        if (this.ForecastData.controls['Floating_Date'].value != null && this.ForecastData.controls['Floating_Date2'].value != null) {
          const start = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date2'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date2'].value != null) {

            this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff3 = this.dayDiff3 - (Math.floor(this.dayDiff3 / 7) * (7 - this.forecastDataVM.ActiveDays));
            //this.dayDiff3 = this.dayDiff3 -(Math.floor(this.dayDiff3/7)* (7-this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance);
          }
          else {
            this.FloatingSMU2 = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance)
          }
        }
      }
    } else {
      if (value == 1) {
        if (this.ForecastData.controls['PM_1_Date'].value != null) {
          this._minDateSecoundPm = this.ForecastData.controls['PM_1_Date'].value;
          const start = new Date(this.forecastDataVM.LastInpectionDateOnly).getTime();
          const end = new Date(this.ForecastData.controls['PM_1_Date'].value).getTime();
          const diff = end - start;
          this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));

          if (this.calculatedUsaghourChecked) {
            this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }
          else {
            this.NextPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
            this.NextPmDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours1 = (this.NextPMSMU - this.forecastDataVM.LastinspectionSMU);
            this.diffBetweenLastandPreviousInpectionDistance1 = (this.NextPmDistance - this.forecastDataVM.LastInspectionDistance)
          }

        }

      } else if (value == 2) {
        this.conditionalCalculatedValue = false;
        this._minDateFlaotingDate1 = this.ForecastData.controls['PM_2_Date'].value;
        if (this.ForecastData.controls['PM_1_Date'].value != null && this.ForecastData.controls['PM_2_Date'].value != null) {

          let startdate = this.ForecastData.controls['PM_1_Date'].value;
          let endDate = this.ForecastData.controls['PM_2_Date'].value;
          const start = new Date(startdate).getTime();
          const end = new Date(endDate).getTime();
          const diff = end - start;
          if (endDate != null) {
            this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff1 = this.dayDiff1 - (Math.floor(this.dayDiff1 / 7) * (7 - this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance)
          }
          else {
            this.SecondPMSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff1) + (+this.NextPMSMU);
            this.SecondDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff1) + (+this.NextPmDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours2 = (this.SecondPMSMU - this.NextPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance2 = (this.SecondDistance - this.NextPmDistance);
          }


        }

      } else if (value == 3) {
        this._minDateFlaotingDate2 = this.ForecastData.controls['Floating_Date'].value;
        if (this.ForecastData.controls['PM_2_Date'].value != null && this.ForecastData.controls['Floating_Date'].value != null) {
          const start = new Date(this.ForecastData.controls['PM_2_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date'].value != null) {

            this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff2 = this.dayDiff2 - (Math.floor(this.dayDiff2 / 7) * (7 - this.forecastDataVM.ActiveDays));

          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance);
          }
          else {
            this.FloatingSMU = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff2) + (+this.SecondPMSMU);
            this.FloatingDistance = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff2) + (+this.SecondDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours3 = (this.FloatingSMU - this.SecondPMSMU);
            this.diffBetweenLastandPreviousInpectionDistance3 = (this.FloatingDistance - this.SecondDistance)
          }

        }

      } else {

        if (this.ForecastData.controls['Floating_Date'].value != null && this.ForecastData.controls['Floating_Date2'].value != null) {
          const start = new Date(this.ForecastData.controls['Floating_Date'].value).getTime();
          const end = new Date(this.ForecastData.controls['Floating_Date2'].value).getTime();
          const diff = end - start;
          if (this.ForecastData.controls['Floating_Date2'].value != null) {

            this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
            this.dayDiff3 = this.dayDiff3 - (Math.floor(this.dayDiff3 / 7) * (7 - this.forecastDataVM.ActiveDays));
            //this.dayDiff3 = this.dayDiff3 -(Math.floor(this.dayDiff3/7)* (7-this.forecastDataVM.ActiveDays));
          }
          if (this.calculatedUsaghourChecked) {
            this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance);
          }
          else {
            this.FloatingSMU2 = (this.ForecastData.controls['Daily_Usage_Hours'].value * this.dayDiff3) + (+this.FloatingSMU);
            this.FloatingDistance2 = (this.ForecastData.controls['Daily_Usage_Distance'].value * this.dayDiff3) + (+this.FloatingDistance);
            this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
            this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance)
          }
        }
      }
    }

  }

  onSubmit() {
    // debugger;
    //console.log("Controlvalue:",this.ForecastData.controls['PM_2_Date'].value)
    // this.refreshComponents = false;
    var foreCastData = new TRACKForcastVM();
    foreCastData.InspectionId = this.InspectionId;
    foreCastData.DailyUsageHours = this.ForecastData.controls['Daily_Usage_Hours'].value;
    foreCastData.DailyUageDistance = this.convertDistanceMiToKm(this.ForecastData.controls['Daily_Usage_Distance'].value);
    foreCastData.ForecastMethod = this.hourChecked ? "Hours" : "Distance";// this.ForecastData.controls['Forecast_Method'].value == "1" ? "Hours" : "Distance";
    // foreCastData.PmNextDateService = moment(new Date(this.ForecastData.controls['PM_1_Date'].value)).toDate();
    foreCastData.PmNextDateService = this.ForecastData.controls['PM_1_Date'].value != null ? new Date(this.ForecastData.controls['PM_1_Date'].value) : null;
    foreCastData.PmNextDateServiceString = this.ForecastData.controls['PM_1_Date'].value != null ? moment(this.ForecastData.controls['PM_1_Date'].value).format('MM/DD/YYYY') : null;

    foreCastData.SecondPmNextDateService = this.ForecastData.controls['PM_2_Date'].value != null ? new Date(this.ForecastData.controls['PM_2_Date'].value) : null;
    foreCastData.SecondPmNextDateServiceString = this.ForecastData.controls['PM_2_Date'].value != null ? moment(this.ForecastData.controls['PM_2_Date'].value).format('MM/DD/YYYY') : null;

    // foreCastData.SecondPmNextDateService = moment(new Date(this.ForecastData.controls['PM_2_Date'].value)).toDate();

    foreCastData.FloatingDate = this.ForecastData.controls['Floating_Date'].value != null ? new Date(this.ForecastData.controls['Floating_Date'].value) : null;
    foreCastData.FloatingDateString = this.ForecastData.controls['Floating_Date'].value != null ? moment(this.ForecastData.controls['Floating_Date'].value).format('MM/DD/YYYY') : null;

    foreCastData.FloatingDate2 = this.ForecastData.controls['Floating_Date2'].value != null ? new Date(this.ForecastData.controls['Floating_Date2'].value) : null;
    foreCastData.FloatingDateString2 = this.ForecastData.controls['Floating_Date2'].value != null ? moment(this.ForecastData.controls['Floating_Date2'].value).format('MM/DD/YYYY') : null;
    // foreCastData.FloatingDate = moment(new Date(this.ForecastData.controls['Floating_Date'].value)).toDate();

    foreCastData.PmNextDateServiceSMU = +this.NextPMSMU;
    foreCastData.PmNextDateServiceDOE = this.convertDistanceMiToKm(+this.NextPmDistance);
    foreCastData.SecondPmNextDateServiceSMU = +this.SecondPMSMU;
    foreCastData.SecondPmNextDateServiceDOE = this.convertDistanceMiToKm(+this.SecondDistance);
    foreCastData.FloatingSMU = +this.FloatingSMU;
    foreCastData.FloatingDOE = this.convertDistanceMiToKm(+this.FloatingDistance);
    foreCastData.FloatingSMU2 = +this.FloatingSMU2;
    foreCastData.FloatingDOE2 = this.convertDistanceMiToKm(+this.FloatingDistance2);
    foreCastData.DailyUsageCalculationMethod = this.calculatedUsaghourChecked == true ? "calculated" : "manually";
    foreCastData.Show100Worn = this.ForecastData.controls['show100Worn'].value;
    foreCastData.Show120Worn = this.ForecastData.controls['show120Worn'].value;
    foreCastData.ShowLastFourth = this.ForecastData.controls['showLastFourth'].value;

    foreCastData.PmNextServiceType = this.ForecastData.controls['PmNextServiceType'].value;
    foreCastData.PmSecondServiceType = this.ForecastData.controls['PmSecondServiceType'].value;
    foreCastData.FloatingDate1ServiceType = this.ForecastData.controls['FloatingDate1ServiceType'].value;
    foreCastData.FloatingDate2ServiceType = this.ForecastData.controls['FloatingDate2ServiceType'].value;
    foreCastData.SafetyFactor = this.ForecastData.controls['SafteyFactor'].value;
    foreCastData.WeatherTypeId = this.ForecastData.controls['WeatherType'].value;
    foreCastData.ForecastCalculationMethod = Number(this.selectedValue);
    foreCastData.DistanceRatio = this.ForecastData.controls['DistanceRatio'].value;
     foreCastData.MidpointPercentage = this.ForecastData.controls['MidpointPercentage'].value;
    this._interp.SaveForeCastData(foreCastData).subscribe(
      res => {
        if (res == 1) {
          this._notify.success('Success', 'record saved successfully');
          this.getDailyUsagehoursAndDailyDistance();
        }
      },
      () => {
        this._notify.error('Error saving data', 'Failed to save the record');
      }
    );

  }
  convertDistanceMiToKm(val: number): number {
    return this.userUOD === 'km' ? val : Math.round(val * 1.60934);
  }

  OnRefresh(): void {

    this.dialogRef.close(true);
  }

  PmServiceTypesVM: PmServiceTypesVM;
  PmServiceTypes: PmServiceTypes[] = [];
  GetPmServiceData() {
    this._planerService.GetPmServiceTypes().subscribe(result => {
      if (result != null) {
        this.PmServiceTypes = result.Data;

        this.PmServiceTypesVM = result;
      }
    });
  }

  NavigateTo() {
    window.open(`/forecast-configuration`, '_blank');
  }
  limitOneDecimal(event: any) {
  let value = event.target.value;

  const regex = /^\d+(\.\d{0,1})?/;

  const match = value.match(regex);
  if (match) {
    event.target.value = match[0];
    this.ForecastData.controls['DistanceRatio'].setValue(match[0]);
  } else {
    event.target.value = '';
    this.ForecastData.controls['DistanceRatio'].setValue(0);
  }
}

}
